import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import cs from 'classnames';

import { setDataLayer } from 'shared/actions/globals';
import { isValidPhone } from 'shared/validations/validations';
import { withFetch } from 'shared/hocs/withFetch';

import { addSuggestion } from 'shared/helpers/suggest/suggest';

import { userFormValidation } from 'shared/helpers/leasing/utils';
import { withTranslate } from 'shared/hocs/withTranslate';
import CarsNameEmailForm from './CarsNameEmailForm';
import NameEmailFormMobile from './NameEmailFormMobile';
import PartsNameEmailForm from './PartsNameEmailForm';

import SuggestionResultForm from './../SuggestionResultForm/SuggestionResultForm';
// eslint-disable-next-line css-modules/no-unused-class
import s from './../LeasingOnlineBanner.css';

const APP = __APP__;
const isMobile = APP === 'mobile';

class LeasingOnlineBanner extends React.Component {
  static propTypes = {
    modalMode: PropTypes.bool,
    advert: PropTypes.shape().isRequired,

    user: PropTypes.shape(),
    fetch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: null,
    modalMode: false,
  };

  constructor(props) {
    super(props);
    const { user } = this.props;
    const userName = (user && user.name) || '';
    const phone = (user && user.phones && user.phones[0].number) || '';

    this.state = {
      userName,
      carLocation: '',
      phone,
      errorMessage: '',
      successMessage: '',
      step: 'user',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnCodeVerification: false,
    };
  }

  onSubmitForm = e => {
    e.preventDefault();
    const { phone, userName } = this.state;
    const errorMsg = userFormValidation({ phone, userName });

    if (errorMsg) {
      this.setState({ errorMessage: errorMsg });
      return;
    }

    // this.fireEvent('consultation');
    this.setState({ disableBtnLeasing: true });
    this.submitSuggestion(isSuccess => {
      this.setState({ disableBtnLeasing: false });
      const toState = {
        userName: '',
        phone: '',
        errorMessage:
          !isSuccess &&
          'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
        successMessage: '',
        step: isSuccess ? 'result' : this.state.step,
      };
      this.setState(toState);
    });
  };

  onSuggestionCreated = success => {
    console.log(success);
  };

  submitSuggestion = cb => {
    const { phone, userName, carLocation } = this.state;
    const { advert, fetch } = this.props;
    console.log('Create submit form');
    addSuggestion({ phone, userName, carLocation, advert }, fetch)
      .then(data => {
        cb(!!data);
        this.onSuggestionCreated(!!data);
      })
      .catch(() => {
        cb(false);
        this.onSuggestionCreated(false);
      });

    return false;
  };

  changeHandler = (field, value) => {
    this.setState({ [field]: value, errorMessage: '' });
  };

  validateForm = params => {
    const { phone } = params;
    if (phone && !isValidPhone(phone.replace(/\s/g, ''))) {
      this.setState({ errorMessage: 'Некорректный номер телефона' });
      return false;
    }
    return true;
  };
  render() {
    const advert = this.props.advert;
    let NameEmailForm;

    if (isMobile) {
      NameEmailForm = NameEmailFormMobile;
    } else {
      NameEmailForm = advert.transport ? CarsNameEmailForm : PartsNameEmailForm;
    }
    return (
      <div
        className={cs({
          [s.container]: true,
          [s.LeasingContainerContentSidebar]: !this.props.modalMode,
        })}
      >
        {this.state.step === 'user' && (
          <NameEmailForm
            advert={advert}
            disableBtnLeasing={this.state.disableBtnLeasing}
            userName={this.state.userName}
            phone={this.state.phone}
            carLocation={this.state.carLocation}
            errorMessage={this.state.errorMessage}
            successMessage={this.state.successMessage}
            changeHandler={this.changeHandler}
            onSubmitHandler={this.onSubmitForm}
          />
        )}
        {this.state.step === 'result' && (
          <div className={s.LeasingContainerContent}>
            <SuggestionResultForm />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = { setDataLayer };
const mapStateToProps = state => ({
  user: state.user && state.user.user,
});

export default withStyles(s)(
  withFetch(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(withTranslate(LeasingOnlineBanner)),
  ),
);



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestForm/SuggestForm.js